export const fetchScopeData = async () => {
  const conn_name = "crmwidgetconnection";
  const apiUrl =
    "https://www.zohoapis.com/creator/v2.1/data/sst1source/source-erp/report/Scope_of_QMS_Report/4599841000005403007";

  const req_data = {
    method: "GET",
    url: apiUrl,
    param_type: 1,
  };

  try {
    const response = await ZOHO.CRM.CONNECTION.invoke(conn_name, req_data);

    if (!response || !response.details || !response.details.statusMessage) {
      console.error("❌ Invalid response structure:", response);
      return [];
    }

    let records = response.details.statusMessage.data;

    // ✅ Handle case where records is not an array
    if (!Array.isArray(records)) {
      console.warn("⚠️ Fetched data is not an array, wrapping it in an array.");
      records = [records];
    }

    console.log("✅ Parsed Quality Scope Records:", records);

    return records.map((item) => ({
      id: item.ID,
      scopeText: item.Objective_Description || "No Scope text available",
      ...item,
    }));
  } catch (error) {
    console.error("❌ Error fetching Quality Scope data:", error);
    return [];
  }
};
